import Select, { components as C } from 'react-select';
import { Check, Search, X } from 'lucide-react';
import { selectClassNames } from 'components/Profile/helper';

const Control = (props) => (
  <C.Control {...props}>
    <Search size={16} className="shrink-0 text-gray-400" />
    {props.children}
  </C.Control>
);

const ClearSearch = ({ selectProps }) => {
  if (!selectProps.inputValue) return null;

  const clear = (e) => {
    e.preventDefault();
    selectProps.onInputChange('', { action: 'input-change', prevInputValue: selectProps.inputValue });
    selectProps.onMenuClose();
  };

  return (
    <button type="button" aria-label="Clear search" onMouseDown={clear} className="shrink-0 text-gray-400 hover:text-gray-600">
      <X size={16} />
    </button>
  );
};

// Bolds the typed text inside the record name.
const Highlight = ({ text, query }) => {
  const start = query ? text.toLowerCase().indexOf(query) : -1;

  if (start < 0) return text;

  return (
    <>
      {text.slice(0, start)}
      <span className="font-bold text-base-content">{text.slice(start, start + query.length)}</span>
      {text.slice(start + query.length)}
    </>
  );
};

const Option = (props) => (
  <C.Option {...props}>
    <span className="flex items-center justify-between gap-3">
      <span className="min-w-0 truncate text-sm">
        <Highlight text={props.data.label} query={props.selectProps.inputValue.trim().toLowerCase()} />
      </span>
      {props.isSelected && <Check size={16} strokeWidth={2.5} className="shrink-0 text-teamcare-blue" />}
    </span>
  </C.Option>
);

const SearchPicker = ({ name, items, picked, onChange, placeholder }) => {
  const options = items.map(({ id, attributes }) => ({ value: id, label: attributes.name }));
  const selected = options.filter(({ value }) => picked?.[value]);

  // react-select hands back the selected options; turn that into the { id: checked } map the checkboxes use.
  const handleChange = (next) => {
    const ids = new Set(next.map(({ value }) => value));
    onChange(Object.fromEntries(items.map(({ id }) => [id, ids.has(id)])));
  };

  return (
    <div className="mb-4">
      <Select
        unstyled
        isMulti
        inputId={`${name}-search`}
        aria-label={placeholder}
        placeholder={placeholder}
        options={options}
        value={selected}
        onChange={handleChange}
        isClearable={false}
        backspaceRemovesValue={false}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        openMenuOnClick={false}
        openMenuOnFocus={false}
        noOptionsMessage={() => 'No matches — describe it under Anything Else below.'}
        components={{ Control, Option, DropdownIndicator: ClearSearch }}
        classNames={{
          ...selectClassNames,
          control: () => `${selectClassNames.control()} bg-white focus-within:border-teamcare-blue focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-teamcare-blue/30`,
          input: () => 'text-sm',
          placeholder: () => 'truncate text-sm text-gray-400',
        }}
      />

      <p className="mt-1.5 text-xs text-gray-400">
        Type to search by name. Use ↑ ↓ and Enter to pick.
      </p>
    </div>
  );
};

export default SearchPicker;
